import styled from 'styled-components';

export const DefaultButton = styled.button`
  border-radius: 0.2rem;
  background-color: ${(props) => props.theme.colors.main.medium};
  :hover {
    background-color: ${(props) => props.theme.colors.main.dark};
  }
  border: none;
`;
